import type { Directory } from '@/types/accessor/s3/directory'
import { S3ServiceException } from '@aws-sdk/client-s3'

export const useS3Utils = () => {
  /**
   * AWSErrorかどうかを判定するタイプガード
   * @param {unknown} arg エラーオブジェクト
   * @returns {boolean} AWSErrorフラグ
   */
  const isAWSError = (arg: unknown): arg is S3ServiceException => {
    return arg instanceof S3ServiceException
  }

  /**
   * バックエンドで生成されたS3 objectKeyからprefixとfileNameを抽出
   * @param objectKey S3オブジェクトキー : {自治体コード}/{災害ID}/{調査対象ID}/floorPlan/floorPlan_{アップロード日時（ミリ秒付13桁)}_{hash値}.{拡張子}
   * @returns - {prefix, fileName}
   */
  const extractPrefixAndFileName = (objectKey: string): { prefix: string; fileName: string } => {
    // バックエンドにて生成されたobjectKeyからprefixとfileNameを取得する
    // objectKey: {自治体コード}/{災害ID}/{調査対象ID}/floorPlan/floorPlan_{アップロード日時（ミリ秒付13桁)}_{hash値}.{拡張子}
    const lastSlashIndex = objectKey.lastIndexOf('/')
    const prefix = objectKey.substring(0, lastSlashIndex + 1)
    const fileName = objectKey.substring(lastSlashIndex + 1)
    return { prefix, fileName }
  }

  /**
   * ファイルディレクトリ名生成
   * @param {Directory} directoryParams ディレクトリ生成に必要なデータ群
   * @returns {string} ファイルディレクトリ名 {govCode}/{disasterID}/{applicationId}/{part}/
   */
  const generateDirectory = (directoryParams: Directory): string => {
    const { govCode, disasterId } = directoryParams
    return [govCode, disasterId].join('/') + '/'
  }

  /**
   * 0パディングされた値を取得する
   * @param {number} num シリアルナンバー
   * @param {number} digit 桁数
   * @return 0001, 00000000001など
   */
  const getZeroPaddedNumber = (num: number, digit: number): string => {
    const numString: string = num.toString()
    const zeros: string = '0'.repeat(digit - numString.length)
    return zeros + numString
  }

  const downloadFile = (file: File) => {
    const url = URL.createObjectURL(file)

    const a = document.createElement('a')
    a.href = url
    a.download = file.name

    document.body.appendChild(a)
    a.click()

    // 後処理
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  return {
    isAWSError,
    extractPrefixAndFileName,
    generateDirectory,
    getZeroPaddedNumber,
    downloadFile
  }
}
